export default __webpack_public_path__ + "static/media/LibbyKeyser.f7218347.jpg";